import React, { useContext, useEffect, useRef, useState } from "react";
import { TreeSelect, Form, Table, message, Typography, Space } from "antd";
import { commafy } from "../../../helpers/stringFormat";
import { backendPatchWithoutRefresh, backendPostWithoutRefresh } from "../../../helpers/callBackend";
import { errorMessage } from "../../../helpers/errorMessageFunc";
// import GenericTableOnRowOnClick from "../../../components/tables/genericTableOnRowOnClick";
import GenericTableOnRowOnClick1 from "../../../components/tables/genericTableOnRowOnClick1";
import TransactionDrawer from "../../../components/bankAccount/transactions/completedDrawer";
import TransactionsRowDropdown from "../../../components/specific/transactions/transactionsRowDropdown";
import moment from "moment";
import { Box, Button, TextField } from '@mui/material';
import { getGridNumericOperators } from '@mui/x-data-grid';
import GenericTagChips from "../../../components/specific/customTags/genericTagChips";
import PermissionGate from '../../../helpers/PermissionGate'


const { TreeNode } = TreeSelect;
const EditableContext = React.createContext(null);
var AccountLedgerData = "";
var HeaderLedgerData = "";

const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  var childCategory = [];
  var parentCategory = [];
  var temp = [];

  for (var j = 0; j < AccountLedgerData.length; j++) {
    var val =
      AccountLedgerData[
      AccountLedgerData.findIndex(
        (item) => item.id === AccountLedgerData[j].total_into_id
      )
      ];
    var parcat = val ? val["description"] : "";
    if (
      AccountLedgerData[j]["description"].split(" ")[0] !== "TOTAL" &&
      parcat !== ""
    ) {
      if (!temp.includes(parcat)) {
        temp.push(parcat);
        parentCategory.push([parcat, val["report_type"]]);
      }
      childCategory.push([AccountLedgerData[j]["description"], parcat]);
    }
  }

  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);

  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      if (values.category === "") {
        errorMessage("Category Cannot be Empty");
        return;
      }
      if (
        values.category.split("::")[1] === record["category"] &&
        values.category.split("::")[0] === record["parentcategory"]
      ) {
        message.warning("Same Category Submitted");
        return;
      }
      var data = {
        id: record['id'],
        category: values.category.split("::")[1],
        parentCategory: values.category.split("::")[0],
      };
      values.parentcategory = values.category.split("::")[0];
      values.category = values.category.split("::")[1];
      if (data["category"] && data["parentCategory"]) {
        handleSave({ ...record, ...values });
        backendPatchWithoutRefresh("/api/transactions/", data);
      } else {
        errorMessage("Category field cannot be empty");
      }
    } catch (errInfo) {
      console.error("Save failed:", errInfo);
    }
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
          padding: 0,
        }}
        name={dataIndex}
        rules={[
          {
            required: true,
            message: `Category is required.`,
          },
        ]}
      >
        <TreeSelect
          showSearch
          style={{
            width: 300,
          }}
          placeholder="Pick a Category"
          allowClear
          ref={inputRef}
          onChange={save}
        >
          <TreeNode
            value={"Balance Sheet"}
            title={"Balance Sheet"}
            selectable={false}
          >
            {parentCategory.map((head) =>
              head[1] === "BAL" ? (
                <TreeNode value={head[0]} title={head[0]} selectable={false}>
                  {childCategory.map((account) =>
                    account[1] === head[0] ? (
                      <TreeNode
                        value={head[0] + "::" + account[0]}
                        title={account[0]}
                      />
                    ) : (
                      ""
                    )
                  )}
                </TreeNode>
              ) : (
                ""
              )
            )}
          </TreeNode>
          <TreeNode
            value={"Income Sheet"}
            title={"Income Sheet"}
            selectable={false}
          >
            {parentCategory.map((head) =>
              head[1] === "INC" ? (
                <TreeNode value={head[0]} title={head[0]} selectable={false}>
                  {childCategory.map((account) =>
                    account[1] === head[0] ? (
                      <TreeNode
                        value={head[0] + "::" + account[0]}
                        title={account[0]}
                      />
                    ) : (
                      ""
                    )
                  )}
                </TreeNode>
              ) : (
                ""
              )
            )}
          </TreeNode>
        </TreeSelect>
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          padding: 0,
          margin: 0,
        }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};

/**
 * Editable transactions table. Lots of optional props.
 * 
 * @param {*} props
 * 
 * @prop {array.object} data transactions data to be displayed from the backend
 * @prop {boolean} pending if true, disables row expansion for edits, hides placement column, also used for filtering data source
 * @prop {boolean} loading if true, display table loading skeleton over top 3 rows
 * @prop {callable} onLoadTransactions function to execute when the Load/Transactions button is pressed
 * @returns 
 */
const EditTable = (props) => {
  const [selectedTransaction, setSelectedTransaction] = useState({ counterparty_name: "" });
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [showLoadMore, setShowLoadMore] = useState(true);

  AccountLedgerData = getLedgers([...(props.AccountLedgerData || [])]);
  HeaderLedgerData = getLedgers([...(props.HeaderLedgerData || [])]);

  function getLedgers(ledgerData) {
    var data = [];
    for (var i = 0; i < ledgerData.length; i++) {
      data.push(ledgerData[i]);
    }
    return data;
  }

  const [dataSource, setDataSource] = React.useState(props.data ? props.data.filter((txn) => (props.pending || txn.is_trash === false)) : props.data);
  const updateStatus = React.useRef(null);

  function setUpdate() {
    setDataSource(props.data ? props.data.filter((txn) => (props.pending || txn.is_trash === false)) : props.data);
  }

  useEffect(() => {
    if (!updateStatus.current) {
      setUpdate();
    }
  }, [props.data]);

  const handleTableChange = (pagination, filters, sorter, extra) => {
    if (pagination.current === Math.ceil(extra.currentDataSource.length / pagination.pageSize)) {
      setShowLoadMore(true);
    } else {
      setShowLoadMore(false);
    }
  }

  const InputNumberInterval = ({ item, applyValue }) => {
    const [min, max] = Array.isArray(item.value) ? item.value : ["", ""];

    const handleChange = (index, newValue) => {
      // Ensure `item.value` is always an array with two elements
      const updatedValue = [...(Array.isArray(item.value) ? item.value : ["", ""])];
      updatedValue[index] = newValue ? Number(newValue) : "";

      // Apply the updated value properly
      applyValue({ ...item, value: updatedValue });
    };

    return (
      <Box display="flex" sx={{ mt: 2 }} gap={1}>
        <TextField
          variant="standard"
          placeholder="Min"
          value={min}
          onChange={(e) => handleChange(0, e.target.value)}
          fullWidth
        />
        <TextField
          variant="standard"
          placeholder="Max"
          value={max}
          onChange={(e) => handleChange(1, e.target.value)}
          fullWidth
        />
      </Box>
    );
  };

  const betweenOperator = {
    label: 'Between',
    value: 'between',
    getApplyFilterFn: (filterItem) => {
      if (!Array.isArray(filterItem.value) || filterItem.value.length !== 2) {
        return null;
      }
      const [min, max] = filterItem.value.map(Number); // Convert values to numbers

      if (isNaN(min) || isNaN(max)) {
        return null;
      }

      return (value) => {
        return value != null && min <= value && value <= max;
      };
    },
    InputComponent: InputNumberInterval,
  };


  const defaultColumns = [
    {
      field: 'timestamp',
      headerName: 'Date',
      flex: 1.5,
      sortable: true,
      sortComparator: (v1, v2) => new Date(v1).getTime() - new Date(v2).getTime(),
      renderCell: (params) => (
        <span>
          {params?.row?.timestamp?.slice(0, 10)}
          <span style={{ fontStyle: 'italic', color: 'lightgrey', fontSize: '14px', paddingLeft: '10px' }}>
            {moment(params?.row?.timestamp).format('h:mm A')}
          </span>
        </span>
      ),
    },
    ...(props.pending === false ? [{
      field: 'subportfolioName',
      headerName: 'Placement',
      flex: 2.5,
      renderCell: (params) => (
        <Box
          sx={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflowWrap: 'anywhere'
          }}
        >
          <GenericTagChips
            genericMap={{ 'account': params.row?.account_description }}
            genericTags={params.row.account_generic_tags}
            bank={params.row?.info?.bank?.name}
          />
        </Box>
      ),
    }] : []),
    {
      field: 'counterparty_name',
      headerName: 'To/From',
      flex: 1.5,
      renderCell: (params) => (
        <p style={{ textTransform: 'capitalize', margin: 0 }}>
          {params?.row?.counterparty_name}
        </p>
      ),
    },
    {
      field: 'description',
      headerName: 'Description',
      flex: 2.5,
      renderCell: (params) => (
        <Box
          sx={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflowWrap: 'anywhere',
          }}
        >
          <Typography
            variant="body1"
            color="primary"
            component="span"
          >
            {params?.row?.description}
          </Typography>
          {params?.row?.notes?.length > 0 && (<Typography
            variant="body2"
            color="textSecondary"
            style={{ fontSize: '12px', fontStyle: 'italic', paddingLeft: '10px' }}
            component="span"
          >
            {params?.row?.notes}
          </Typography>)}
        </Box>
      ),
    },
    {
      field: 'amount',
      headerName: 'Amount',
      flex: 1,
      align: 'right',
      filterOperators: [
        ...getGridNumericOperators().filter((operator) =>
          ['>', '<'].includes(operator.value) // Include only '>' and '<'
        ),
        betweenOperator,
      ],
      renderCell: (params) => (
        <>
          {String(params?.row?.amount)?.charAt(0) === '-' ? (
            <span>
              ($
              {commafy(
                parseFloat(
                  String(params?.row?.amount)?.slice(1)
                ).toFixed(2)
              )}
              )
            </span>
          ) : (
            <span>
              ${commafy(parseFloat(params?.row?.amount)?.toFixed(2))}
            </span>
          )}
        </>
      ),
    },
    {
      field: 'balance',
      headerName: 'Balance',
      flex: 1,
      align: 'right',
      renderCell: (params) => {
        if (params.row.balance == "0.00") {
          return <></>;
        }
        return (
          <>
            {String(params?.row?.balance)?.charAt(0) === '-' ? (
              <span>
                ($
                {commafy(
                  parseFloat(
                    String(params?.row?.balance)?.slice(1)
                  ).toFixed(2)
                )}
                )
              </span>
            ) : (
              <span>
                ${commafy(parseFloat(params?.row?.balance).toFixed(2))}
              </span>
            )}
          </>
        )
      },
    },
    ...(props.generalLedgerRulePage
      ? [
        {
          field: 'general_ledger_account_id',
          headerName: 'G/L Account',
          flex: 1.5,
          renderCell: (params) => {
            const isNone = !params?.row?.general_ledger_account_id;
            const isHighlighted =
              params?.row?.general_ledger_account_id !==
              props?.ruleData?.gl_account_id;
            return (
              <span
                style={{
                  color: isNone
                    ? 'lightgrey'
                    : isHighlighted
                      ? '#f5222d'
                      : 'inherit',
                  fontStyle: isNone ? 'italic' : 'normal',
                }}
              >
                {isNone ? 'UNTAGGED' : params?.row?.general_ledger_account_tag}
              </span>
            );
          },
        },
      ]
      : []),
    ...(props.customTagRulePage
      ? [
        {
          field: 'generic_tags',
          headerName: 'Custom Tag',
          flex: 1.5,
          renderCell: (params) => {
            const isNone = !params?.row?.generic_tags.length;
            const isHighlighted = !params?.row?.generic_tags.some(tag => tag.id === props?.ruleData?.tag_id);
            return (
              <span
                style={{
                  color: isNone
                    ? 'lightgrey'
                    : isHighlighted
                      ? '#f5222d'
                      : 'inherit',
                  fontStyle: isNone ? 'italic' : 'normal',
                }}
              >
                {isNone ? 'UNTAGGED' : params?.row?.generic_tags.map(tag => tag.name).join(', ')}
              </span>
            );
          },
        },
      ]
      : []),
    {
      field: 'action',
      headerName: '',
      flex: 0.5,
      align: 'right',
      renderCell: (params) => (
        <PermissionGate requiredRole='dashboardEditor'>
          <TransactionsRowDropdown
            pending={props.pending}
            selectedTransaction={params?.row}
            updateSplitTransactions={props?.updateSplitTransactions}
          />
        </PermissionGate>
      ),
    },
  ];

  const handleSave = (row) => {
    const newData = [...dataSource];
    const index = newData.findIndex(
      (item) => row.id === item.id
    );
    newData.splice(index, 1, row);

    setDataSource(newData);

    const response = {
      action: "category update",
      data: [...newData],
      record: { ...row },
    };
    props.onChange(response);
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };
  const columns = defaultColumns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
      }),
    };
  });

  // Centralized transaction update handler
  const updateTransactionInState = (transactionId, updatedTransaction) => {
    // Update the main data source
    if (props.updateTransaction) {
      props.updateTransaction(transactionId, updatedTransaction);
    }
    
    // Update local data source for immediate UI reflection
    setDataSource(prevData => {
      if (!prevData) return prevData;
      return prevData.map(transaction => 
        transaction.id === transactionId ? updatedTransaction : transaction
      );
    });
    
    // Update selected transaction if it's the one being edited
    setSelectedTransaction(prevSelected => {
      if (prevSelected.id === transactionId) {
        return updatedTransaction;
      }
      return prevSelected;
    });
  };

  const handleCounterpartyNameChange = async (counterpartyName) => {
    const transactionId = selectedTransaction.id;
    
    try {
      const res = await backendPatchWithoutRefresh("/api/transactions/", {
        id: transactionId,
        counterparty_name: counterpartyName,
      });
      
      const updatedTransaction = res.data.data;
      updateTransactionInState(transactionId, updatedTransaction);
    } catch (error) {
      console.error('Failed to update counterparty name:', error);
      message.error('Failed to update counterparty name');
    }
  };

  const handleCounterpartyAssign = async (counterpartyId) => {
    const transactionId = selectedTransaction.id;
    
    try {
      const res = await backendPatchWithoutRefresh("/api/transactions/", {
        id: transactionId,
        counterparty_id: counterpartyId,
      });
      
      const updatedTransaction = res.data.data;
      updateTransactionInState(transactionId, updatedTransaction);
    } catch (error) {
      console.error('Failed to assign counterparty:', error);
      message.error('Failed to assign counterparty');
    }
  };

  // Keep the original useEffect for external data updates
  useEffect(() => {
    if (selectedTransaction.id) {
      const updatedTransaction = props.data?.find(transaction => transaction.id === selectedTransaction.id);
      if (updatedTransaction && JSON.stringify(updatedTransaction) !== JSON.stringify(selectedTransaction)) {
        setSelectedTransaction(updatedTransaction);
      }
    }
  }, [props.data, selectedTransaction.id]);

  const handleDateChange = (newDate) => {
    const journalTransaction = {
      ...selectedTransaction,
      id: selectedTransaction.id + ".journal",
      description: "Journal",
      amount: -1 * selectedTransaction.amount,
      is_original: false,
      is_journal: true,
      is_manual: true,
    }

    const newTransaction = {
      ...selectedTransaction,
      id: selectedTransaction.id + ".1",
      timestamp: newDate,
      is_original: false,
      is_manual: true,
      is_journal: false,
    }

    const transactions = [journalTransaction, newTransaction];
    const data = {
      bank_account_id: selectedTransaction?.info?.bank_account_id,
      transactions: transactions,
      original_transaction_id: selectedTransaction.id,
    }
    backendPostWithoutRefresh("/api/transactions/", data)
      .then((response) => {
        if (props.updateTransactions) {
          props.updateTransactions(response.data.transactions, selectedTransaction.id);
        }
      })
      .catch((error) => {
        message.error("Something went wrong");
        console.error(error);
      });
  }

  const handleNotesChange = async (newNotes) => {
    const transactionId = selectedTransaction.id;
    
    try {
      const res = await backendPatchWithoutRefresh("/api/transactions/", {
        id: transactionId,
        notes: newNotes,
      });
      
      const updatedTransaction = res.data.data;
      updateTransactionInState(transactionId, updatedTransaction);
    } catch (error) {
      console.error('Failed to update notes:', error);
      message.error('Failed to update notes');
    }
  };

  const handleEditableFieldUpdate = async (field, value) => {
    const transactionId = selectedTransaction.id;
    let params = {
      id: transactionId
    };
    params[field] = value;
    
    try {
      const patchResponse = await backendPatchWithoutRefresh("/api/transactions/", params);
      
      if (patchResponse.status === 200) {
        const updatedTransaction = patchResponse.data.data;
        updateTransactionInState(transactionId, updatedTransaction);
        return updatedTransaction;
      }
    } catch (error) {
      console.error(`Failed to update ${field}:`, error);
      message.error(`Failed to update ${field}`);
      throw error;
    }
  };

  const handleCustomCategoriesChange = (updatedTransaction) => {
    const transactionId = selectedTransaction.id;
    updateTransactionInState(transactionId, updatedTransaction);
  };

  const handleApproveEdits = (updatedTransaction) => {
    const transactionId = selectedTransaction.id;
    updateTransactionInState(transactionId, updatedTransaction);
  };

  // Generic transaction update handler for the drawer
  const handleTransactionUpdate = (updatedTransaction) => {
    updateTransactionInState(updatedTransaction.id, updatedTransaction);
  };

  const handleExpand = (expanded, record) => {
    if (expanded) {
      setSelectedTransaction(record);
      setExpandedRowKeys([record.id]);
    } else {
      setExpandedRowKeys([]);
    }
  };

  const TransactionDrawerX = () => (
    <TransactionDrawer
      open={true}
      loading={props.loading}
      selectedTransaction={selectedTransaction}
      handleCounterpartyNameChange={handleCounterpartyNameChange}
      handleDateChange={handleDateChange}
      portfolioName={props.subportfolioName}
      propertyName={props.propertyName}
      bankAccountName={props.bankAccountName}
      handleNotesChange={handleNotesChange}
      customCategories={props.customCategories}
      handleCustomCategoriesChange={handleCustomCategoriesChange}
      handleApproveEdits={handleApproveEdits}
      handleEditableFieldUpdate={handleEditableFieldUpdate}
      handleCounterpartyAssign={handleCounterpartyAssign}
      onTransactionUpdate={handleTransactionUpdate}
    />
  )

  return (
    <GenericTableOnRowOnClick1
      pagination={{
        paginationModel: { pageSize: dataSource?.length || 50, page: 0 },
      }}
      pageSizeOptions={[5, 10, 25, 50]}
      columns={columns}
      dataSource={
        dataSource
      }
      enableExpandable={!props.pending}
      transactionDrawerComponent={TransactionDrawerX}
      drawerWidth={"40%"}
      handleExpand={handleExpand}
      optInRowHeightAuto={true}
      getRowId={(record) => record.id}
      components={components}
      allTransactionsTable={true}
      loading={props.loading || false}
      onChange={handleTableChange}
      {...((showLoadMore && !props.generalLedgerRulePage && !props.customTagRulePage) ? {
        footer: () => (
          <Box display="flex" justifyContent="center" mt={2}>
            <Button
              sx={{ fontSize: 14, textTransform: "none", width: "220px" }}
              disableElevation
              fullWidth
              size="small"
              type="submit"
              variant="outlined"
              color="secondary"
              onClick={() => props.onLoadTransactions({ month: props.currentMonth, year: props.currentYear })}
              disabled={props.transactionsLoading}
            >
              Load {props.currentMonth}/{props.currentYear} Transactions
            </Button>
          </Box>
        )
      } : {})}
    />
  );
};

export default EditTable;